import { useActiveTournament } from '../state/TournamentContext';
import { useActiveRole } from '../state/RoleContext';
import { useStore } from '../hooks/useStore';
import { getDb } from '../services/store';
import { getPlayerStats } from '../services/scoringService';
import { BadgeCheck } from 'lucide-react';

/**
 * Player "My Stats" lens for the public event view. Filters tournament-wide
 * player stats down to the active profile so they see only themselves.
 */
export function EventMyStatsPage() {
  const { tournament, teams } = useActiveTournament();
  const { profile } = useActiveRole();
  useStore((d) => d);
  const db = getDb();

  const myPlayer = db.players.find((p) => p.profileId === profile.id);
  const stats = myPlayer
    ? getPlayerStats(tournament.id).find((s) => s.playerId === myPlayer.id)
    : undefined;

  if (!myPlayer || !stats) {
    return (
      <div className="card">
        <div className="empty">
          No player profile in this tournament. Switch to a player profile in the preview switcher.
        </div>
      </div>
    );
  }

  const myTeam = teams.find((t) => t.id === stats.teamId);

  return (
    <div className="card">
      <div className="card__head">
        <div>
          <h3 className="card__title">
            <BadgeCheck size={16} style={{ verticalAlign: -2, marginRight: 6 }} />
            {profile.displayName}
          </h3>
          <p className="card__sub">{myTeam?.name ?? ''}</p>
        </div>
      </div>
      <div className="grid grid--4">
        <Stat label="Games" value={stats.gamesPlayed} />
        <Stat label="Goals" value={stats.goals} />
        <Stat label="Assists" value={stats.assists} />
        <Stat label="Points" value={stats.points} />
        <Stat label="Shootout" value={`${stats.shootoutGoals}/${stats.shootoutAttempts}`} />
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="card">
      <div className="eyebrow">{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700 }}>{value}</div>
    </div>
  );
}
